import { useEffect, useState } from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { DateAvailabilityOut, OrderService, TimeSlotResponseOut } from '../../../../api';
import { DATE_FORMAT } from '../../../calendarWrapper/CalendarWrapper';

type UseEditOrderDatesParams = {
  isEventOrCourse: boolean;
  accountId: string;
  orderPageId: string;
  orderDetails: any;
  currentDate: string;
};

type UseEditOrderDatesResult = {
  availableDatesForEvents: DateAvailabilityOut[];
  availableTimesForEvent: TimeSlotResponseOut[];
  isLoadingDates: boolean;
  shouldDisableDate: (value: moment.Moment) => boolean;
};

export const useEditOrderDates = ({
  isEventOrCourse,
  accountId,
  orderPageId,
  orderDetails,
  currentDate,
}: UseEditOrderDatesParams): UseEditOrderDatesResult => {
  const [availableDatesForEvents, setAvailableDatesForEvents] = useState<DateAvailabilityOut[]>([]);
  const [availableTimesForEvent, setAvailableTimesForEvent] = useState<TimeSlotResponseOut[]>([]);
  const [isLoadingDates, setIsLoadingDates] = useState(false);

  useEffect(() => {
    void (async () => {
      if (isEventOrCourse) {
        setIsLoadingDates(true);
        const availableDates = await OrderService.getAvailableDatesAdmin({
          account_id: accountId,
          order_page_id: orderPageId,
          order_details: { ...orderDetails, persons: 0 },
        });
        setAvailableDatesForEvents(availableDates);
      } else {
        setAvailableDatesForEvents([]);
      }
      setIsLoadingDates(false);
    })();
  }, [orderPageId]);

  useEffect(() => {
    if (!isEventOrCourse) return;
    setAvailableTimesForEvent(availableDatesForEvents.find((x) => x.date === currentDate)?.times || []);
  }, [availableDatesForEvents, currentDate]);

  const shouldDisableDate = (value: moment.Moment) => {
    if (!isEventOrCourse || isEmpty(availableDatesForEvents)) return false;
    return !availableDatesForEvents.find((x) => x.date === value.format(DATE_FORMAT));
  };

  return { availableDatesForEvents, availableTimesForEvent, isLoadingDates, shouldDisableDate };
};
